import { useState, useEffect } from "react";
import { jwtDecode } from "jwt-decode";
import {
  updateAppointmentPatientId,
  createPatient,
  createAccount,
  updateAccount,
  checkMultipleAccounts,
  checkMultiplePatients,
  getPracticesByNumbers,
  generatePatAccNumber,
  updatePatAccNumber,
} from "../../api";
import Button from "react-bootstrap/Button";
import InputGroup from "react-bootstrap/InputGroup";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import Modal from "react-bootstrap/Modal";
import Nav from "react-bootstrap/Nav";
import cssc from "./AddPatients.module.css";
import React from "react";
import AccountSearch from "../SearchAccounts/SearchAccounts";
import Alert from "react-bootstrap/Alert";
import { FaCheck, FaTimes, FaPlus, FaTrash } from "react-icons/fa";
import SearchMedAidPatient from "./SearchMedAidFamily";
import { useNavigate } from "react-router-dom";
import "./PatientAccounts.css";

function PatientInformationModal(props) {
  const {
    show,
    onHide,
    patientFirstName,
    patientLastName,
    patientEmail,
    patientCellNumber,
    appointmentId,
  } = props;

  const [currentStep, setCurrentStep] = useState(1);
  const [patientMode, setPatientMode] = useState(null);
  const [userId, setUserId] = useState("");
  const [practices, setPractices] = useState([]);
  const [patPractice, setPatPractice] = useState("");
  const [selectedPracticeNumbers, setSelectedPracticeNumbers] = useState([]);
  const [accountPatient, setAccountPatient] = useState("");
  const [patientId, setPatientId] = useState("1");
  const [practice, setAPractice] = useState([]);
  const [accountId, setAccountId] = useState("1");
  const [alerts, setAlerts] = useState(false);
  const [closeAlert, setCloseAlert] = useState(false);
  const [postalAddress, setPostalAddress] = useState(false);
  const [apStatus, setApStatus] = useState("");
  const [accountSelected, setAccountSelected] = useState(false);
  const [selectedDependant, setSelectedDependant] = useState(null);
  const [selectedMedicalAid, setSelectedMedicalAid] = useState(false);
  const [mainMemberAccount, setMainMemberAccount] = useState(null);
  const [multipleAccountsError, setMultipleAccountsError] = useState(false);
  const [multipleAccountsErrorMessage, setMultipleAccountsErrorMessage] =
    useState("");
  const [errors, setErrors] = useState({});
  const [notFoundAlert, setNotFoundAlert] = useState(false);
  const [lastPatientNumber, setLastPatientNumber] = useState(null);
  const [lastAccountNumber, setLastAccountNumber] = useState(null);
  const [iodCommittedAt, setIodCommittedAt] = useState(0);
  const [iodLocked, setIodLocked] = useState(false);

  const Navigate = useNavigate();

  const togglePractice = async (practiceNumber) => {
    setSelectedPracticeNumbers((prev) => {
      const exists = prev.includes(practiceNumber);
      if (exists) {
        // Don't allow unchecking the last remaining one
        if (prev.length === 1) return prev;
        return prev.filter((p) => p !== practiceNumber);
      } else {
        return [...prev, practiceNumber];
      }
    });
    const result = await generatePatAccNumber(
      selectedPracticeNumbers.includes(practiceNumber)
        ? selectedPracticeNumbers.filter((p) => p !== practiceNumber)
        : [...selectedPracticeNumbers, practiceNumber],
    );

    if (result) {
      const { patientNumber, accountNumber } = result;

      setPatient((prevPatient) => ({
        ...prevPatient,
        patientNumber,
      }));

      setPatientAccount((prevPatientAccount) => ({
        ...prevPatientAccount,
        accountNumber,
      }));
      setLastPatientNumber(patientNumber);
      setLastAccountNumber(accountNumber);
    }
  };

  useEffect(() => {
    setPatient((prevPatient) => ({
      ...prevPatient,
      patientFirstName: patientFirstName || "",
      patientLastName: patientLastName || "",
      patientEmail: patientEmail || "",
      patientCellNumber: patientCellNumber || "",
    }));
  }, [show, patientFirstName, patientLastName, patientEmail]);

  // Patient Information State
  const [patient, setPatient] = useState({
    patientNumber: "",
    patientTitle: "",
    patientInitials: "",
    patientFullNames: "",
    patientFirstName: "",
    patientLastName: "",
    patientDOB: "",
    patientIdNumber: "",
    patientCellNumber: "",
    patientEmail: "",
    patientGender: "",
    patientHomeLanguage: "",
    patientMedicalAid: "",
    patientMedicalAidCode: "",
    patientMedicalAidPlan: "",
    patientMedicalAidPlanCode: "",
    patientMedicalAidOption: "",
    patientMedicalAidOptionCode: "",
    patientMedicalAidNumber: "",
    patientMedicalAidDependent: "",
    patientMedicalAidDependantCode: "",
    patientMedicalAidStatus: "",
    patientMedicalAidJoinDate: "",
    patientMedicalAidLastCheck: "",
    patientMainMember: "",
    patientMediKreditPlanNumber03: "",
    patientMediKreditPlanNumber04: "",
    patientMediKreditPlanNumber06: "",
    iodPatient: "",
    patientIODFund: "",
    patientIODFundCode: "",
    patientIODPlan: "",
    patientIODPlanCode: "",
    patientIODOption: "",
    patientIODOptionCode: "",
    patientIODClaimRefNumber: "",
    patientIODEmployer: "",
    patientIODDateOfInjury: "",
    patientIODEmployerWCARegNum: "",
    // Auditing
    patientCreatedBy: "",
    patientCreatedDate: "",
    patientPractice: "",
    patientReferredBy: "",
    patientReferredNotes: "",
  });
  const [mainMemberPatient, setMainMemberPatient] = useState({
    patientNumber: "",
    patientTitle: "",
    patientInitials: "",
    patientFullNames: "",
    patientFirstName: "",
    patientLastName: "",
    patientDOB: "",
    patientIdNumber: "",
    patientCellNumber: "",
    patientEmail: "",
    patientGender: "",
    patientHomeLanguage: "",
    patientMedicalAid: "",
    patientMedicalAidCode: "",
    patientMedicalAidPlan: "",
    patientMedicalAidPlanCode: "",
    patientMedicalAidOption: "",
    patientMedicalAidOptionCode: "",
    patientMedicalAidNumber: "",
    patientMedicalAidDependent: "",
    patientMedicalAidDependantCode: "",
    patientMedicalAidStatus: "",
    patientMedicalAidJoinDate: "",
    patientMedicalAidLastCheck: "",
    patientMainMember: "",
    patientMediKreditPlanNumber03: "",
    patientMediKreditPlanNumber04: "",
    patientMediKreditPlanNumber06: "",
    iodPatient: "",
    patientIODFund: "",
    patientIODFundCode: "",
    patientIODPlan: "",
    patientIODPlanCode: "",
    patientIODOption: "",
    patientIODOptionCode: "",
    patientIODClaimRefNumber: "",
    patientIODEmployer: "",
    patientIODDateOfInjury: "",
    patientIODEmployerWCARegNum: "",
    // Auditing
    patientCreatedBy: "",
    patientCreatedDate: "",
    patientPractice: "",
    patientReferredBy: "",
    patientReferredNotes: "",
  });

  // Account Information State
  const [patientAccount, setPatientAccount] = useState({
    accountNumber: "",
    accountTitle: "",
    accountFullNames: "",
    accountInitials: "",
    accountFirstName: "",
    accountLastName: "",
    accountIdNumber: "",
    accountDOB: "",
    accountEmail: "",
    accountEmail2: undefined,
    accountEmail3: undefined,
    accountEmail4: undefined,
    accountEmail5: undefined,
    accountTelNumberCell: "",
    accountTelNumberHome: "",
    accountTelNumberWork: "",
    accountHomeAddress1: "",
    accountHomeAddress2: "",
    accountHomeAddressCity: "",
    accountHomeAddressProvince: "",
    accountHomeAddressPostalCode: "",
    accountPostalAddress1: "",
    accountPostalAddress2: "",
    accountPostalAddressCity: "",
    accountPostalAddressProvince: "",
    accountPostalAddressPostalCode: "",
    accountEmployer: "",
    accountOccupation: "",
    accountMedicalAid: "",
    accountMedicalAidCode: "",
    accountMedicalAidPlan: "",
    accountMedicalAidPlanCode: "",
    accountMedicalAidOption: "",
    accountMedicalAidOptionCode: "",
    accountMedicalAidNumber: "",
    accountMedicalAidDependents: "", //array of dependants ._id
    accountMedicalAidLastCheck: "",
    accountMedicalAidStatus: "",
    accountMedicalAidJoinDate: "",
    accountPractice: "",
    accountPatientId: "", // _id of patient
    iodAccount: "",
    accountIODFund: "",
    accountIODFundCode: "",
    accountIODPlan: "",
    accountIODPlandCode: "",
    accountIODOption: "",
    accountIODOptionCode: "",
    accountIODClaimRefNumber: "",
    accountIODEmployer: "",
    accountIODDateOfInjury: "",
    accountIODEmployerWCARegNum: "",
    // Auditing
    accountCreatedBy: "",
    accountCreatedDate: "",
  });

  const handlePatientModeChange = (mode) => {
    setPatientMode((prev) => (prev === mode ? null : mode));
  };

  useEffect(() => {
    const loadPractice = async () => {
      try {
        const token = sessionStorage.getItem("user");
        if (!token) return; // optional: redirect/login here

        const decoded = jwtDecode(token);
        setUserId(decoded._id);

        const userPractice = decoded.practice; // could be a single number or array
        setAPractice(userPractice);

        // Normalise to array if needed
        const practiceNumbers = Array.isArray(userPractice)
          ? userPractice
          : [userPractice];
        const practiceData = await getPracticesByNumbers(practiceNumbers);
        setPractices(practiceData); // now you have full practice objects
      } catch (err) {
        console.error("Failed to load practice info:", err);
      }
    };

    loadPractice();
  }, []);

  // Ensure default selection when practices load or modal opens
  useEffect(() => {
    const initializePractice = async () => {
      if (show && practices && practices.length > 0) {
        const defaultPracticeNumber = practices[0].practiceNumber;
        // ✅ First practice selected by default
        setSelectedPracticeNumbers([defaultPracticeNumber]);

        // Directly call API with the practice number (don't use togglePractice to avoid toggle logic issues)
        const result = await generatePatAccNumber([defaultPracticeNumber]);
        if (result) {
          const { patientNumber, accountNumber } = result;
          setPatient((prevPatient) => ({
            ...prevPatient,
            patientNumber,
          }));
          setPatientAccount((prevPatientAccount) => ({
            ...prevPatientAccount,
            accountNumber,
          }));
          setLastPatientNumber(patientNumber);
          setLastAccountNumber(accountNumber);
        }
      }
    };
    initializePractice();
  }, [practices, show]);

  // Keep patPractice in sync with selections (many-to-many)
  useEffect(() => {
    setPatPractice(selectedPracticeNumbers);
  }, [selectedPracticeNumbers]);

  // Sync practice into patient/account state whenever patPractice changes
  // Prevents "" being submitted if user never fires handleChangePatient
  useEffect(() => {
    if (!patPractice || (Array.isArray(patPractice) && patPractice.length === 0)) return;
    setPatient((prev) => ({ ...prev, patientPractice: patPractice }));
    setMainMemberPatient((prev) => ({ ...prev, patientPractice: patPractice }));
    setPatientAccount((prev) => ({ ...prev, accountPractice: patPractice }));
  }, [patPractice]);

  // Handling the change of the input fields
  async function handleChangePatient(e) {
    const { name, value, checked } = e.target;
    setPatient((prevPatient) => ({
      ...prevPatient,
      [e.target.name]: e.target.value,
      patientCreatedBy: userId,
      patientPractice: patPractice,
    }));
    setPatientAccount((prevPatientAccount) => ({
      ...prevPatientAccount,
      [e.target.name]: e.target.value,
      accountCreatedBy: userId,
      accountPractice: patPractice,
    }));

    if (
      patientMode === "EXISTING_ACCOUNT" &&
      patientAccount.accountMedicalAid === ""
    ) {
      setPatient((prevPatient) => ({
        ...prevPatient,
        patientMedicalAidDependantCode: "99",
      }));
    }
  }

  function handleChangeAccount(e) {
    const { name, value } = e.target;
    setPatientAccount((prevPatientAccount) => ({
      ...prevPatientAccount,
      [e.target.name]: e.target.value,
      accountCreatedBy: userId,
      accountPatientId: patientId,
    }));
    if (patientMode === "EXISTING_ACCOUNT") {
      if (name === "accountLastName") {
        setPatientAccount((prevPatientAccount) => ({
          ...prevPatientAccount,
          accountInitials: value,
          accountPatientId: patientId,
        }));
      }
    }
    if (
      patientMode === "EXISTING_ACCOUNT" &&
      patientAccount.accountMedicalAid === ""
    ) {
      setPatient((prevPatient) => ({
        ...prevPatient,
        patientMedicalAidDependantCode: "99",
      }));
    }
    if (name === "accountPostal") {
      // If the patient have a medical aid show medical aid fields
      setPostalAddress(true);
    }
  }

  function handleChangeReferral(e) {
    const { name } = e.target;
    setPatient((prevPatient) => ({
      ...prevPatient,
      [e.target.name]: e.target.value,
    }));
  }

  const validatePatientForm = () => {
    const newErrors = {};

    // ✅ Validate Full Names
    if (!patient.patientFullNames || !patient.patientFullNames.trim()) {
      newErrors.patientFullNames = "Full name(s) is required.";
    }

    // ✅ Validate Initials
    if (!patient.patientInitials || !patient.patientInitials.trim()) {
      newErrors.patientInitials = "Initials are required.";
    }

    // ✅ Validate First Name
    if (!patient.patientFirstName || !patient.patientFirstName.trim()) {
      newErrors.patientFirstName = "First name is required.";
    }

    // ✅ Validate Last Name
    if (!patient.patientLastName || !patient.patientLastName.trim()) {
      newErrors.patientLastName = "Last name is required.";
    }

    // ✅ Validate ID Number (SA 13-digit format)
    // — ID Number (optional) — only validate/auto‐fill if present
    if (patient.patientIdNumber) {
      if (!/^\d{13}$/.test(patient.patientIdNumber)) {
        newErrors.patientIdNumber = "ID number must be 13 digits.";
      } else {
        // extract YYMMDD
        const idDOB = patient.patientIdNumber.substring(0, 6);
        const currentYear = new Date().getFullYear();
        // determine century
        const yy = parseInt(idDOB.substring(0, 2), 10);
        const century = yy > currentYear % 100 ? "19" : "20";
        const fullDOB =
          `${century}${idDOB.substring(0, 2)}-` +
          `${idDOB.substring(2, 4)}-` +
          `${idDOB.substring(4, 6)}`;

        // Auto‐fill DOB if empty or out‐of‐sync
        if (!patient.patientDOB || patient.patientDOB !== fullDOB) {
          patient.patientDOB = fullDOB;
        }
      }
    }

    // — DOB still required & format‐checked as before
    if (!patient.patientDOB) {
      newErrors.patientDOB = "Date of birth is required.";
    } else if (!/^\d{4}-\d{2}-\d{2}$/.test(patient.patientDOB)) {
      newErrors.patientDOB = "Enter a valid date (YYYY-MM-DD).";
    }

    // ✅ Validate Cell Number (South African format)
    if (!patient.patientCellNumber) {
      newErrors.patientCellNumber = "Mobile number is required.";
    } else {
      let formattedNumber = patient.patientCellNumber.trim();

      // Auto-format if it starts with '0' (e.g., 0825811679 -> +27825811679)
      if (/^0[6-8][0-9]{8}$/.test(formattedNumber)) {
        formattedNumber = "+27" + formattedNumber.substring(1);
        patient.patientCellNumber = formattedNumber; // Update the value
      }

      // Validate final format
      if (!/^\+27[6-8][0-9]{8}$/.test(formattedNumber)) {
        newErrors.patientCellNumber =
          "Enter a valid South African mobile number with country code.";
      }
    }

    // ✅ Validate Email
    if (!patient.patientEmail) {
      newErrors.patientEmail = "Email is required.";
    } else if (
      !/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(
        patient.patientEmail,
      )
    ) {
      newErrors.patientEmail = "Enter a valid email address.";
    }

    // ✅ Set Errors and Return Validation Result
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const validateAccountForm = () => {
    const newErrors = {};

    // ✅ Validate Full Names
    if (
      !patientAccount.accountFullNames ||
      !patientAccount.accountFullNames.trim()
    ) {
      newErrors.accountFullNames = "Full name(s) is required.";
    }

    // ✅ Validate Initials
    if (
      !patientAccount.accountInitials ||
      !patientAccount.accountInitials.trim()
    ) {
      newErrors.accountInitials = "Initials are required.";
    }

    // ✅ Validate First Name
    if (
      !patientAccount.accountFirstName ||
      !patientAccount.accountFirstName.trim()
    ) {
      newErrors.accountFirstName = "First name is required.";
    }

    // ✅ Validate Last Name
    if (
      !patientAccount.accountLastName ||
      !patientAccount.accountLastName.trim()
    ) {
      newErrors.accountLastName = "Last name is required.";
    }

    // ✅ Validate Date of Birth (Must be in YYYY-MM-DD format)
    if (!patientAccount.accountDOB) {
      newErrors.accountDOB = "Date of birth is required.";
    } else if (!/^\d{4}-\d{2}-\d{2}$/.test(patientAccount.accountDOB)) {
      newErrors.accountDOB = "Enter a valid date (YYYY-MM-DD).";
    }

    // ✅ Validate ID Number
    if (
      !/^\d{13}$/.test(patientAccount.accountIdNumber) &&
      patientAccount.accountIdNumber
    ) {
      newErrors.accountIdNumber = "ID number must be 13 digits.";
    }

    // ✅ Validate Cell Number
    if (!patientAccount.accountTelNumberCell) {
      newErrors.accountTelNumberCell = "Mobile number is required.";
    } else {
      let formattedNumber = patientAccount.accountTelNumberCell.trim();

      // Auto-format if it starts with '0' (e.g., 0821234567 -> +27821234567)
      if (/^0[6-8][0-9]{8}$/.test(formattedNumber)) {
        formattedNumber = "+27" + formattedNumber.substring(1);
        patientAccount.accountTelNumberCell = formattedNumber; // Update the value
      }

      // Validate final format
      if (!/^\+27[6-8][0-9]{8}$/.test(formattedNumber)) {
        newErrors.accountTelNumberCell =
          "Enter a valid South African mobile number with country code.";
      }
    }

    // ✅ Validate Email
    if (!patientAccount.accountEmail) {
      newErrors.accountEmail = "Email is required.";
    } else if (
      !/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(
        patientAccount.accountEmail,
      )
    ) {
      newErrors.accountEmail = "Enter a valid email address.";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const extractDobFromId = (id) => {
    if (!/^\d{13}$/.test(id)) return null;
    const idDOB = id.substring(0, 6);
    const currentYear = new Date().getFullYear();
    const century =
      parseInt(idDOB.substring(0, 2)) > currentYear % 100 ? "19" : "20";
    return `${century}${idDOB.substring(0, 2)}-${idDOB.substring(
      2,
      4,
    )}-${idDOB.substring(4, 6)}`;
  };

  const handlePatientIdBlur = () => {
    const dob = extractDobFromId(patient.patientIdNumber);
    if (dob) {
      setPatient((prev) => ({
        ...prev,
        patientDOB: dob,
      }));
    }
  };

  const handleAccountIdBlur = () => {
    const dob = extractDobFromId(patientAccount.accountIdNumber);
    if (dob) {
      setPatientAccount((prev) => ({
        ...prev,
        accountDOB: dob,
      }));
    }
  };

  async function handleNext(e) {
    e.preventDefault();

    // ✅ Step 1 Validation (Patient Form)
    if (currentStep === 1) {
      // If validation fails, do not proceed
      if (!validatePatientForm()) {
        return;
      }
      try {
        const response = await checkMultiplePatients(
          practice,
          patient.patientDOB,
          patient.patientFirstName,
          patient.patientLastName,
        );
        if (response.message.includes("The patient")) {
          setMultipleAccountsError(true);
          setMultipleAccountsErrorMessage(response.message);
          setCurrentStep(1);
          return;
        }
      } catch (error) {
        console.error("⛔ Error checking patients:", error);
        setMultipleAccountsError(true);
        setCurrentStep(1);
        return;
      }
      if (patientMode === "ACCOUNT_HOLDER" || patientMode === "IOD") {
        setPatientAccount((prevPatientAccount) => ({
          ...prevPatientAccount,
          accountNumber: patientAccount?.accountNumber,
          accountTitle: patient?.patientTitle,
          accountFullNames: patient?.patientFullNames,
          accountFirstName: patient?.patientFirstName,
          accountLastName: patient?.patientLastName,
          accountInitials: patient?.patientInitials,
          accountIdNumber: patient?.patientIdNumber,
          accountDOB: patient?.patientDOB,
          accountEmail: patient?.patientEmail,
          accountTelNumberCell: patient?.patientCellNumber,
          accountMedicalAid: patient?.patientMedicalAid,
          accountMedicalAidCode: patient?.patientMedicalAidCode,
          accountMedicalAidOption: patient?.patientMedicalAidOption,
          accountMedicalAidOptionCode: patient?.patientMedicalAidOptionCode,
          accountMedicalAidPlan: patient?.patientMedicalAidPlan,
          accountMedicalAidPlanCode: patient?.patientMedicalAidPlanCode,
          accountMedicalAidNumber: patient?.patientMedicalAidNumber,
          accountMedicalAidDependents: patient?.patientMedicalAidDependent,
          accountMediKreditPlanNumber03:
            patient?.patientMediKreditPlanNumber03 ||
            patient?.patientMediKreditPlanNumber04 ||
            patient?.patientMediKreditPlanNumber06,
          accountMediKreditPlanNumber04: patient?.patientMediKreditPlanNumber04,
          accountMediKreditPlanNumber06: patient?.patientMediKreditPlanNumber06,
          accountMedicalAidLastCheck: patient?.patientMedicalAidLastCheck,
          accountMedicalAidStatus: patient?.patientMedicalAidStatus,
          accountMedicalAidJoinDate: patient?.patientMedicalAidJoinDate,
          accountIODFund: patient?.patientIODFund,
          accountIODFundCode: patient?.patientIODFundCode,
          accountIODPlan: patient?.patientIODPlan,
          accountIODPlanCode: patient?.patientIODPlanCode,
          accountIODClaimRefNumber: patient?.patientIODClaimRefNumber,
          accountIODEmployer: patient?.patientIODEmployer,
          accountIODEmployerWCARegNum: patient?.patientIODEmployerWCARegNum,
          accountIODDateOfInjury: patient?.patientIODDateOfInjury,
        }));
        setPatient((prevPatient) => ({
          ...prevPatient,
          patientMainMember: true, // Set patient as main member
        }));
      }
    }

    // ✅ Step 2 Validation (Account Form) - Only runs when moving from Step 2 to 3
    if (currentStep === 2) {
      if (
        patientMode !== "EXISTING_ACCOUNT" &&
        patientAccount.accountIdNumber
      ) {
        try {
          const iod = patientMode === "IOD";
          const response = await checkMultipleAccounts(
            practice,
            patientAccount.accountIdNumber,
            iod,
          );

          if (response.message.includes("already exists")) {
            setMultipleAccountsError(true);
            setMultipleAccountsErrorMessage(response.message);
            setCurrentStep(1);
            return;
          }
        } catch (error) {
          console.error("⛔ Error checking accounts:", error);
          setMultipleAccountsError(true);
          setCurrentStep(1);
          return;
        }
      }
    }

    // ✅ Proceed to the next step if all validations pass
    if (currentStep < 3) {
      setCurrentStep(currentStep + 1);
    }
  }

  async function handlePrevious(e) {
    e.preventDefault();
    if (currentStep === 2) {
      setCurrentStep(1);
      if (selectedDependant !== "") {
        setSelectedMedicalAid(true);
      }
    }
    if (currentStep === 3) {
      setCurrentStep(2);
    }
  }

  async function handleSave() {
    if (currentStep === 3) {
      setCurrentStep(3);
      if (patientId === "1") {
        let response;
        try {
          response = await createPatient(patient);
        } catch (err) {
          const msg =
            err?.response?.data?.message ||
            "Failed to create patient. The patient number may already be in use.";
          setMultipleAccountsErrorMessage(msg);
          setMultipleAccountsError(true);
          return;
        }
        if (response.status === 200) {
          let newPatientId = response.data.insertedId;

          // Update state but use newPatientId immediately
          setPatientId(newPatientId);
          setAccountPatient(newPatientId);
          if (appointmentId !== "1") {
            setApStatus("Confirmed");
            try {
              await updateAppointmentPatientId(
                appointmentId,
                newPatientId,
                "Confirmed",
              );
            } catch (e) {
              console.error("updateAppointmentPatientId failed", e);
              // Handle the error - maybe don't proceed with onSaved if this fails
              return;
            }
          }

          // Ensure patient ID is available before creating an account
          if (
            patientMode === "ACCOUNT_HOLDER" ||
            patientMode !== "EXISTING_ACCOUNT"
          ) {
            let patientAccountWithId = {
              ...patientAccount,
              accountPatientId: newPatientId,
            }; // Ensure the correct patientId is used
            let aresponse;
            try {
              aresponse = await createAccount(patientAccountWithId);
            } catch (err) {
              const msg =
                err?.response?.data?.message ||
                "Failed to create account. The account number may already be in use.";
              setMultipleAccountsErrorMessage(msg);
              setMultipleAccountsError(true);
              return;
            }

            if (aresponse.status === 200) {
              let newAccountId = aresponse.data.insertedId;
              setAccountId(newAccountId);
            }
          }
          if (patientMode === "EXISTING_ACCOUNT") {
            let accountWithId = {
              ...patientAccount,
              accountPatientId: newPatientId,
            }; // Ensure the correct patientId is used
            await updateAccount(accountId, accountWithId);
          }
        }
        setAlerts(true);
        setTimeout(() => {
          setAlerts(false);
          props.onHide?.(); // Close the modal

          setCurrentStep(1); // Reset to first step
        }, 2000); // 2000ms = 2 seconds //Setting the SAVE button to move to the first step
        setPatient({});
        setPatientAccount({});
        onHide(onHide);
        setPostalAddress(false);
        setPatientId("1");
        setAccountId("1");
        setAccountSelected(false);
        setSelectedDependant("");
        setNotFoundAlert(false);
        setSelectedPracticeNumbers([]);
        setPatientMode(null);
        Navigate(0); // Refresh the page to show the new patient
      }
    }
  }

  function handleClose() {
    setCloseAlert(true); // Show confirmation alert
  }

  const handleCancelNo = () => {
    setCloseAlert(false); // Hide alert and keep modal open
  };

  const handleCancelYes = async () => {
    setCloseAlert(false); // Hide alert first
    setPatient({});
    setPatientMode(null);
    setPatientAccount({});
    onHide(onHide);
    setPostalAddress(false);
    setCurrentStep(1);
    setPatientId("1");
    setAccountId("1");
    setAccountSelected(false);
    setSelectedMedicalAid(false);
    setMainMemberAccount("");
    setSelectedDependant("");
    setErrors({});
    setNotFoundAlert(false);
    // Close the modal after successful operation
  };

  // If the patient is the account holder populate the account fields
  useEffect(() => {
    if (patientMode === "EXISTING_ACCOUNT" && accountSelected) {
      setPatient((prevPatient) => ({
        ...prevPatient,
        patientMedicalAid: patientAccount?.accountMedicalAid,
        patientMedicalAidCode: patientAccount?.accountMedicalAidCode,
        patientMedicalAidOption: patientAccount?.accountMedicalAidOption,
        patientMedicalAidOptionCode:
          patientAccount?.accountMedicalAidOptionCode,
        patientMedicalAidPlan: patientAccount?.accountMedicalAidPlan,
        patientMedicalAidPlanCode: patientAccount?.accountMedicalAidPlanCode,
        patientMedicalAidNumber: patientAccount?.accountMedicalAidNumber,
        patientMediKreditPlanNumber03:
          patientAccount?.accountMediKreditPlanNumber03 ||
          patientAccount?.accountMediKreditPlanNumber04 ||
          patientAccount?.accountMediKreditPlanNumber06,
        patientMediKreditPlanNumber04:
          patientAccount?.accountMediKreditPlanNumber04,
        patientMedikreditPlanNumber06:
          patientAccount?.accountMediKreditPlanNumber06,
        patientIODFund: "",
        patientIODFundCode: patientAccount?.accountIODFundCode,
        patientIODPlan: patientAccount?.accountIODPlan,
        patientIODPlandCode: patientAccount?.accountIODPlandCode,
        patientIODOption: patientAccount?.accountIODOption,
        patientIODOptionCode: patientAccount?.accountIODOptionCode,
        patientIODClaimRefNumber: patientAccount?.accountIODClaimRefNumber,
        patientIODEmployer: patientAccount?.accountIODEmployer,
        patientIODDateOfInjury: patientAccount?.accountIODDateOfInjury,
        patientIODEmployerWCARegNum:
          patientAccount?.accountIODEmployerWCARegNum,
      }));

      setPatientAccount((prevPatientAccount) => ({
        ...prevPatientAccount,
        accountPatientId: patientId,
        accountId: accountId,
      }));
    }
  }, [patientMode]); // ✅ Only runs when `patientMode` changes, preventing infinite loops

  const addPatientSteps = (dependant, mainMember) => {
    if (dependant) setSelectedDependant(dependant);

    // store the full object (not just code)
    if (patientMode !== "EXISTING_ACCOUNT") {
      setMainMemberAccount(mainMember);
    }
    if (dependant?.__iodCommittedAt) {
      setIodCommittedAt(dependant.__iodCommittedAt);
      setIodLocked(true); // this is what your UI uses to show read-only labels
    }
  };

  useEffect(() => {
    if (!selectedDependant) return;

    const isIOD = patientMode === "IOD";

    const isSelectedTheMainMember = isIOD
      ? true
      : selectedDependant?.dependantCode === mainMemberAccount?.dependantCode;

    const resolvedMainMember = isIOD ? selectedDependant : mainMemberAccount; // main member object ONLY

    // 1) PATIENT always comes from selectedDependant
    setPatient((prev) => ({
      ...prev,
      // medical aid fields (non-IOD)
      patientMedicalAid:
        selectedDependant?.medicalAidInfo?.medicalAid ?? prev.patientMedicalAid,
      patientMedicalAidCode:
        selectedDependant?.medicalAidInfo?.medicalAidCode ??
        prev.patientMedicalAidCode,
      patientMedicalAidOption:
        selectedDependant?.medicalAidInfo?.medicalAidOption ??
        prev.patientMedicalAidOption,
      patientMedicalAidOptionCode:
        selectedDependant?.medicalAidInfo?.medicalAidOptionCode ??
        prev.patientMedicalAidOptionCode,
      patientMedicalAidPlan:
        selectedDependant?.medicalAidInfo?.medicalAidPlan ??
        prev.patientMedicalAidPlan,
      patientMedicalAidPlanCode:
        selectedDependant?.medicalAidInfo?.medicalAidPlanCode ??
        prev.patientMedicalAidPlanCode,
      patientMedicalAidNumber:
        selectedDependant?.medicalAidInfo?.ch_id ??
        prev.patientMedicalAidNumber,
      patientMedicalAidDependantCode:
        selectedDependant?.dependantCode ?? prev.patientMedicalAidDependantCode,

      patientMediKreditPlanNumber03:
        selectedDependant?.medicalAidInfo?.mediKreditPlanNumber03 ??
        prev.patientMediKreditPlanNumber03,
      patientMediKreditPlanNumber04:
        selectedDependant?.medicalAidInfo?.mediKreditPlanNumber04 ??
        prev.patientMediKreditPlanNumber04,
      patientMediKreditPlanNumber06:
        selectedDependant?.medicalAidInfo?.mediKreditPlanNumber06 ??
        prev.patientMediKreditPlanNumber06,

      // person info
      patientFirstName:
        selectedDependant?.dependantFirstName ?? prev.patientFirstName,
      patientFullNames:
        selectedDependant?.dependantFirstName ?? prev.patientFullNames,
      patientLastName:
        selectedDependant?.dependantLastName ?? prev.patientLastName,
      patientInitials:
        selectedDependant?.dependantInitials ?? prev.patientInitials,
      patientDOB: selectedDependant?.dependantDOB ?? prev.patientDOB,
      patientIdNumber: selectedDependant?.dependantID ?? prev.patientIdNumber,

      patientGender:
        selectedDependant?.gender === "Male"
          ? "1"
          : selectedDependant?.gender === "Female"
            ? "2"
            : prev.patientGender,

      patientMedicalAidStatus:
        selectedDependant?.dependantStatus ?? prev.patientMedicalAidStatus,

      patientMedicalAidLastCheck:
        selectedDependant?.medicalAidInfo?.lastCheck ??
        prev.patientMedicalAidLastCheck,

      patientMedicalAidJoinDate:
        selectedDependant?.dependantDateJoined ??
        prev.patientMedicalAidJoinDate,

      patientTitle:
        selectedDependant?.gender === "Male"
          ? "Mr"
          : selectedDependant?.gender === "Female"
            ? "Ms"
            : prev.patientTitle,

      // ✅ boolean: is THIS patient the main member?
      patientMainMember: isSelectedTheMainMember,

      // IOD fields (only if IOD mode)
      ...(isIOD
        ? {
            patientMedicalAidDependantCode: "00", // IOD patients are always non-dependants
            patientIODFund:
              selectedDependant?.iodInfo?.iodFund ?? prev.patientIODFund,
            patientIODFundCode:
              selectedDependant?.iodInfo?.iodFundCode ??
              prev.patientIODFundCode,
            patientIODPlan:
              selectedDependant?.iodInfo?.iodPlan ?? prev.patientIODPlan,
            patientIODPlanCode:
              selectedDependant?.iodInfo?.iodPlanCode ??
              prev.patientIODPlanCode,
            patientIODOption:
              selectedDependant?.iodInfo?.iodOption ?? prev.patientIODOption,
            patientIODOptionCode:
              selectedDependant?.iodInfo?.iodOptionCode ??
              prev.patientIODOptionCode,
            patientIODEmployer:
              selectedDependant?.iodInfo?.iodEmployer ??
              prev.patientIODEmployer,
            patientIODDateOfInjury:
              selectedDependant?.iodInfo?.iodDateOfInjury ??
              prev.patientIODDateOfInjury,
            patientIODEmployerWCARegNum:
              selectedDependant?.iodInfo?.iodEmployerWCARegNum ??
              prev.patientIODEmployerWCARegNum,
            patientIODClaimRefNumber:
              selectedDependant?.iodInfo?.iodClaimRefNumber ??
              prev.patientIODClaimRefNumber,
            patientMediKreditPlanNumber03:
              selectedDependant?.iodInfo?.mediKreditPlanNumber03 ??
              prev.patientMediKreditPlanNumber03,
            patientMediKreditPlanNumber04:
              selectedDependant?.iodInfo?.mediKreditPlanNumber04 ??
              prev.patientMediKreditPlanNumber04,
            patientMediKreditPlanNumber06:
              selectedDependant?.iodInfo?.mediKreditPlanNumber06 ??
              prev.patientMediKreditPlanNumber06,
            patientMainMember: true, // IOD patients are always main members
          }
        : {}),
    }));
    // 2) ACCOUNT should come from the main member person (if you have one)
    if (resolvedMainMember) {
      setPatientAccount((prevAcc) => ({
        ...prevAcc,
        accountMedicalAid:
          resolvedMainMember?.medicalAidInfo?.medicalAid ??
          prevAcc.accountMedicalAid,
        accountMedicalAidNumber:
          resolvedMainMember?.medicalAidInfo?.ch_id ??
          prevAcc.accountMedicalAidNumber,
        accountMedicalAidCode:
          resolvedMainMember?.medicalAidInfo?.medicalAidCode ??
          prevAcc.accountMedicalAidCode,
        accountMedicalAidOption:
          resolvedMainMember?.medicalAidInfo?.medicalAidOption ??
          prevAcc.accountMedicalAidOption,
        accountMedicalAidOptionCode:
          resolvedMainMember?.medicalAidInfo?.medicalAidOptionCode ??
          prevAcc.accountMedicalAidOptionCode,
        accountMedicalAidPlan:
          resolvedMainMember?.medicalAidInfo?.medicalAidPlan ??
          prevAcc.accountMedicalAidPlan,
        accountMedicalAidPlanCode:
          resolvedMainMember?.medicalAidInfo?.medicalAidPlanCode ??
          prevAcc.accountMedicalAidPlanCode,

        accountMediKreditPlanNumber03:
          resolvedMainMember?.medicalAidInfo?.mediKreditPlanNumber03 ??
          prevAcc.accountMediKreditPlanNumber03,
        accountMediKreditPlanNumber04:
          resolvedMainMember?.medicalAidInfo?.mediKreditPlanNumber04 ??
          prevAcc.accountMediKreditPlanNumber04,
        accountMediKreditPlanNumber06:
          resolvedMainMember?.medicalAidInfo?.mediKreditPlanNumber06 ??
          prevAcc.accountMediKreditPlanNumber06,

        ...(isIOD
          ? {
              accountIODFund:
                resolvedMainMember?.iodInfo?.iodFund ?? prevAcc.accountIODFund,
              accountIODFundCode:
                resolvedMainMember?.iodInfo?.iodFundCode ??
                prevAcc.accountIODFundCode,
              accountIODPlan:
                resolvedMainMember?.iodInfo?.iodPlan ?? prevAcc.accountIODPlan,
              accountIODPlanCode:
                resolvedMainMember?.iodInfo?.iodPlanCode ??
                prevAcc.accountIODPlanCode,
              accountIODOption:
                resolvedMainMember?.iodInfo?.iodOption ??
                prevAcc.accountIODOption,
              accountIODOptionCode:
                resolvedMainMember?.iodInfo?.iodOptionCode ??
                prevAcc.accountIODOptionCode,
              accountIODEmployer:
                resolvedMainMember?.iodInfo?.iodEmployer ??
                prevAcc.accountIODEmployer,
              accountIODDateOfInjury:
                resolvedMainMember?.iodInfo?.iodDateOfInjury ??
                prevAcc.accountIODDateOfInjury,
              accountIODEmployerWCARegNum:
                resolvedMainMember?.iodInfo?.iodEmployerWCARegNum ??
                prevAcc.accountIODEmployerWCARegNum,
              accountIODClaimRefNumber:
                resolvedMainMember?.iodInfo?.iodClaimRefNumber ??
                prevAcc.accountIODClaimRefNumber,
              accountMediKreditPlanNumber03:
                resolvedMainMember?.iodInfo?.mediKreditPlanNumber03 ??
                prevAcc.accountMediKreditPlanNumber03,
              accountMediKreditPlanNumber04:
                resolvedMainMember?.iodInfo?.mediKreditPlanNumber04 ??
                prevAcc.accountMediKreditPlanNumber04,
              accountMediKreditPlanNumber06:
                resolvedMainMember?.iodInfo?.mediKreditPlanNumber06 ??
                prevAcc.accountMediKreditPlanNumber06,
            }
          : {}),
      }));
    }
  }, [
    selectedDependant?.dependantCode,
    mainMemberAccount?.dependantCode,
    patientMode,
    iodCommittedAt,
  ]);

  useEffect(() => {
    if (mainMemberAccount) {
      setPatientAccount((prevPatientAccount) => ({
        ...prevPatientAccount,
        accountNumber:
          mainMemberAccount?.accountNumber || prevPatientAccount.accountNumber,
        accountFullNames:
          mainMemberAccount?.dependantFirstName ||
          prevPatientAccount.accountFullNames,
        accountInitials:
          mainMemberAccount?.dependantInitials ||
          prevPatientAccount.accountInitials,
        accountFirstName:
          mainMemberAccount?.dependantFirstName ||
          prevPatientAccount.accountFirstName,
        accountLastName:
          mainMemberAccount?.dependantLastName ||
          prevPatientAccount.accountLastName,
        accountIdNumber:
          mainMemberAccount?.dependantID || prevPatientAccount.accountIdNumber,
        accountDOB:
          mainMemberAccount?.dependantDOB || prevPatientAccount.accountDOB,
        accountEmail:
          mainMemberAccount?.dependantEmail || prevPatientAccount.accountEmail,
        accountTelNumberCell:
          mainMemberAccount?.dependantCellNumber ||
          prevPatientAccount.accountTelNumberCell,
        accountMedicalAid:
          mainMemberAccount?.medicalAidInfo?.medicalAid ||
          prevPatientAccount.accountMedicalAid,
        accountMedicalAidCode:
          mainMemberAccount?.medicalAidInfo?.medicalAidCode ||
          prevPatientAccount.accountMedicalAidCode,
        accountMedicalAidOption:
          mainMemberAccount?.medicalAidInfo?.medicalAidOption ||
          prevPatientAccount.accountMedicalAidOption,
        accountMedicalAidOptionCode:
          mainMemberAccount?.medicalAidInfo?.medicalAidOptionCode ||
          prevPatientAccount.accountMedicalAidOptionCode,
        accountMedicalAidPlan:
          mainMemberAccount?.medicalAidInfo?.medicalAidPlan ||
          prevPatientAccount.accountMedicalAidPlan,
        accountMedicalAidPlanCode:
          mainMemberAccount?.medicalAidInfo?.medicalAidPlanCode ||
          prevPatientAccount.accountMedicalAidPlanCode,
        accountMedicalAidNumber:
          mainMemberAccount?.medicalAidInfo?.ch_id ||
          prevPatientAccount.accountMedicalAidNumber,
        accountMediKreditPlanNumber03:
          mainMemberAccount?.medicalAidInfo?.mediKreditPlanNumber03 ||
          prevPatientAccount.accountMediKreditPlanNumber03 ||
          mainMemberAccount?.medicalAidInfo?.mediKreditPlanNumber04 ||
          prevPatientAccount.accountMediKreditPlanNumber04 ||
          mainMemberAccount?.medicalAidInfo?.mediKreditPlanNumber06 ||
          prevPatientAccount.accountMediKreditPlanNumber06,
        accountMediKreditPlanNumber04:
          mainMemberAccount?.medicalAidInfo?.mediKreditPlanNumber04 ||
          prevPatientAccount.accountMediKreditPlanNumber04,
        accountMediKreditPlanNumber06:
          mainMemberAccount?.medicalAidInfo?.mediKreditPlanNumber06 ||
          prevPatientAccount.accountMediKreditPlanNumber06,
        accountMedicalAidLastCheck:
          mainMemberAccount?.medicalAidInfo?.lastCheck ||
          prevPatientAccount.accountMedicalAidLastCheck,
        accountMedicalAidStatus:
          mainMemberAccount?.dependantStatus ||
          prevPatientAccount.accountMedicalAidStatus,
        accountMedicalAidJoinDate:
          mainMemberAccount?.dependantDateJoined ||
          prevPatientAccount.accountMedicalAidJoinDate,
        accountTitle:
          mainMemberAccount?.gender === "Male"
            ? "Mr"
            : mainMemberAccount?.gender === "Female"
              ? "Ms"
              : prevPatientAccount.accountTitle,

        accountIODFund:
          selectedDependant?.iodInfo?.iodFund ||
          prevPatientAccount.accountIODFund,
        accountIODFundCode:
          selectedDependant?.iodInfo?.iodFundCode ||
          prevPatientAccount.accountIODFundCode,
        accountIODPlan:
          selectedDependant?.iodInfo?.iodPlan ||
          prevPatientAccount.accountIODPlan,
        accountIODPlanCode:
          selectedDependant?.iodInfo?.iodPlanCode ||
          prevPatientAccount.accountIODPlanCode,
        accountIODOption:
          selectedDependant?.iodInfo?.iodOption ||
          prevPatientAccount.accountIODOption,
        accountIODOptionCode:
          selectedDependant?.iodInfo?.iodOptionCode ||
          prevPatientAccount.accountIODOptionCode,
        accountMediKreditPlanNumber03:
          selectedDependant?.iodInfo?.mediKreditPlanNumber03 ||
          prevPatientAccount.accountMediKreditPlanNumber03,
        accountMediKreditPlanNumber04:
          selectedDependant?.iodInfo?.mediKreditPlanNumber04 ||
          prevPatientAccount.accountMediKreditPlanNumber04,
        accountMediKreditPlanNumber06:
          selectedDependant?.iodInfo?.mediKreditPlanNumber06 ||
          prevPatientAccount.accountMediKreditPlanNumber06,
      }));
      setMainMemberPatient((prevMainMemberPatient) => ({
        ...prevMainMemberPatient,
        patientNumber:
          mainMemberAccount?.patientNumber ||
          prevMainMemberPatient.patientNumber,
        patientFullNames:
          mainMemberAccount?.dependantFirstName ||
          prevMainMemberPatient.patientFullNames,
        patientInitials:
          mainMemberAccount?.dependantInitials ||
          prevMainMemberPatient.patientInitials,
        patientFirstName:
          mainMemberAccount?.dependantFirstName ||
          prevMainMemberPatient.patientFirstName,
        patientLastName:
          mainMemberAccount?.dependantLastName ||
          prevMainMemberPatient.patientLastName,
        patientIdNumber:
          mainMemberAccount?.dependantID ||
          prevMainMemberPatient.patientIdNumber,
        patientDOB:
          mainMemberAccount?.dependantDOB || prevMainMemberPatient.patientDOB,
        patientEmail:
          mainMemberAccount?.dependantEmail ||
          prevMainMemberPatient.patientEmail,
        patientTelNumberCell:
          mainMemberAccount?.dependantCellNumber ||
          prevMainMemberPatient.patientCellNumber,
        patientMedicalAid:
          mainMemberAccount?.medicalAidInfo?.medicalAid ||
          prevMainMemberPatient.patientMedicalAid,
        patientMedicalAidCode:
          mainMemberAccount?.medicalAidInfo?.medicalAidCode ||
          prevMainMemberPatient.patientMedicalAidCode,
        patientMedicalAidOption:
          mainMemberAccount?.medicalAidInfo?.medicalAidOption ||
          prevMainMemberPatient.patientMedicalAidOption,
        patientMedicalAidOptionCode:
          mainMemberAccount?.medicalAidInfo?.medicalAidOptionCode ||
          prevMainMemberPatient.patientMedicalAidOptionCode,
        patientMedicalAidPlan:
          mainMemberAccount?.medicalAidInfo?.medicalAidPlan ||
          prevMainMemberPatient.patientMedicalAidPlan,
        patientMedicalAidPlanCode:
          mainMemberAccount?.medicalAidInfo?.medicalAidPlanCode ||
          prevMainMemberPatient.patientMedicalAidPlanCode,
        patientMedicalAidNumber:
          mainMemberAccount?.medicalAidInfo?.ch_id ||
          prevMainMemberPatient.patientMedicalAidNumber,
        patientMediKreditPlanNumber03:
          mainMemberAccount?.medicalAidInfo?.mediKreditPlanNumber03 ||
          prevMainMemberPatient.patientMediKreditPlanNumber03 ||
          mainMemberAccount?.medicalAidInfo?.mediKreditPlanNumber04 ||
          prevMainMemberPatient.patientMediKreditPlanNumber04 ||
          mainMemberAccount?.medicalAidInfo?.mediKreditPlanNumber06 ||
          prevMainMemberPatient.patientMediKreditPlanNumber06,
        patientMediKreditPlanNumber04:
          mainMemberAccount?.medicalAidInfo?.mediKreditPlanNumber04 ||
          prevMainMemberPatient.patientMediKreditPlanNumber04,
        patientMediKreditPlanNumber06:
          mainMemberAccount?.medicalAidInfo?.mediKreditPlanNumber06 ||
          prevMainMemberPatient.patientMediKreditPlanNumber06,
        patientMedicalAidDependantCode:
          mainMemberAccount?.dependantCode ||
          prevMainMemberPatient.patientMedicalAidDependantCode,
        patienttMedicalAidLastCheck:
          mainMemberAccount?.medicalAidInfo?.lastCheck ||
          prevMainMemberPatient.patientMedicalAidLastCheck,
        patientMedicalAidStatus:
          mainMemberAccount?.dependantStatus ||
          prevMainMemberPatient.patientMedicalAidStatus,
        patientMedicalAidJoinDate:
          mainMemberAccount?.dependantDateJoined ||
          prevMainMemberPatient.patientMedicalAidJoinDate,
        patientTitle:
          mainMemberAccount?.gender === "Male"
            ? "Mr"
            : mainMemberAccount?.gender === "Female"
              ? "Ms"
              : prevMainMemberPatient.patientTitle,
        patientMainMember: true,
      }));
    }
  }, [mainMemberAccount, patientMode]); // ✅ Ensure it runs when `accountExisting` changes

  useEffect(() => {
    if (!postalAddress) {
      setPatientAccount((prevPatientAccount) => ({
        ...prevPatientAccount,
        accountPostalAddress1: prevPatientAccount.accountHomeAddress1,
        accountPostalAddress2: prevPatientAccount.accountHomeAddress2,
        accountPostalAddressCity: prevPatientAccount.accountHomeAddressCity,
        accountPostalAddressProvince:
          prevPatientAccount.accountHomeAddressProvince,
        accountPostalAddressPostalCode:
          prevPatientAccount.accountHomeAddressPostalCode,
      }));
    }
  }, [
    patientAccount.accountHomeAddress1,
    patientAccount.accountHomeAddress2,
    patientAccount.accountHomeAddressCity,
    patientAccount.accountHomeAddressProvince,
    patientAccount.accountHomeAddressPostalCode,
    postalAddress,
  ]);

  const EXTRA_EMAIL_FIELDS = [
    "accountEmail2",
    "accountEmail3",
    "accountEmail4",
    "accountEmail5",
  ];

  // Rendering the content of the forms based on the current step
  const renderContent = () => {
    switch (currentStep) {
      case 1:
        return (
          <Form>
            {(patientMode === null || patientMode === "EXISTING_ACCOUNT") && (
              <Row className="mb-1 mt-3">
                <Form.Group as={Col} controlId="checkboxGroup">
                  <Form.Check
                    type="switch"
                    label="The patient can be added to an existing private or medical aid account"
                    checked={patientMode === "EXISTING_ACCOUNT"}
                    onChange={() => handlePatientModeChange("EXISTING_ACCOUNT")}
                  />
                </Form.Group>
              </Row>
            )}

            {patientMode === "EXISTING_ACCOUNT" && (
              <>
                <Row className="mb-3">
                  <AccountSearch
                    onAccountSelect={(account) => {
                      setPatientAccount(account);
                      setAccountId(account._id);
                      setAccountSelected(true);
                    }}
                  />
                </Row>

                {accountSelected && (
                  <>
                    <Row className="mb-1">
                      <Col>
                        <strong>
                          {patientAccount.accountTitle}{" "}
                          {patientAccount.accountInitials}{" "}
                          {patientAccount.accountFirstName}{" "}
                          {patientAccount.accountLastName}
                        </strong>
                      </Col>
                    </Row>

                    <Row className="mb-1">
                      <Col md={4}>
                        <p>
                          <i className="fa-solid fa-id-card text-primary"></i>{" "}
                          {patientAccount.accountIdNumber} <br />
                          <i className="fas fa-phone-alt me-2 text-primary"></i>{" "}
                          {patientAccount.accountTelNumberCell} <br />
                          <i className="fas fa-envelope me-2 text-primary"></i>{" "}
                          {patientAccount.accountEmail}
                        </p>
                      </Col>

                      {patientAccount.accountMedicalAid && (
                        <Col md={4}>
                          <p>
                            <strong>Medical Aid:</strong>{" "}
                            {patientAccount.accountMedicalAid} <br />
                            <strong>Plan:</strong>{" "}
                            {patientAccount.accountMedicalAidPlan} |{" "}
                            {patientAccount.accountMedicalAidOption} <br />
                            <strong>Number:</strong>{" "}
                            {patientAccount.accountMedicalAidNumber} <br />
                          </p>
                        </Col>
                      )}
                    </Row>
                  </>
                )}

                <Row className="mb-3">
                  {patientAccount.accountMedicalAid && (
                    <SearchMedAidPatient
                      addPatientSteps={addPatientSteps}
                      medicalAidMainMember={setMainMemberAccount}
                      patientAccount={patientAccount}
                      accountExisting={true}
                    />
                  )}
                </Row>
              </>
            )}

            {(patientMode === null || patientMode === "MEDICAL_AID") && (
              <Row className="mb-1">
                <Form.Group as={Col}>
                  <Form.Check
                    type="switch"
                    label="New Medical Aid patient without an existing account"
                    checked={patientMode === "MEDICAL_AID"}
                    onChange={() => handlePatientModeChange("MEDICAL_AID")}
                  />
                </Form.Group>
              </Row>
            )}

            {(patientMode === null || patientMode === "IOD") && (
              <Row className="mb-1">
                <Form.Group as={Col}>
                  <Form.Check
                    type="switch"
                    label="Injury on Duty (IOD) Patient"
                    checked={patientMode === "IOD"}
                    onChange={() => handlePatientModeChange("IOD")}
                  />
                </Form.Group>
              </Row>
            )}

            {(patientMode === null || patientMode === "ACCOUNT_HOLDER") && (
              <Row className="mb-1">
                <Form.Group as={Col}>
                  <Form.Check
                    type="switch"
                    label="Private patient responsible for the account"
                    checked={patientMode === "ACCOUNT_HOLDER"}
                    onChange={() => handlePatientModeChange("ACCOUNT_HOLDER")}
                  />
                </Form.Group>
              </Row>
            )}
            {patientMode !== "MEDICAL_AID" &&
              patientMode !== "IOD" &&
              patientMode !== "ACCOUNT_HOLDER" &&
              patientMode !== "EXISTING_ACCOUNT" && (
                <Form.Label className="text-sm text-primary fw-semibold">
                  NOTE: If none of the above are applicable please continue to
                  create the new patient with their account
                </Form.Label>
              )}

            {(patientMode === "MEDICAL_AID" || patientMode === "IOD") &&
              (() => {
                const isMedAid = patientMode === "MEDICAL_AID";
                const isIod = patientMode === "IOD";

                // "completed/selected" state
                const hasMedAidSelection = !!selectedMedicalAid; // your existing flag
                const hasIodSelection =
                  !!patient?.patientIODFund &&
                  !!patient?.patientIODClaimRefNumber;

                const showSummary = isMedAid
                  ? hasMedAidSelection
                  : hasIodSelection;

                if (!showSummary) {
                  return (
                    <SearchMedAidPatient
                      addPatientSteps={addPatientSteps}
                      patientAccount={patientAccount}
                      medicalAidMainMember={setMainMemberAccount}
                      accountExisting={false}
                      iodPatient={isIod}
                    />
                  );
                }

                // ✅ Summary view (2-column)
                return (
                  <div>
                    {isMedAid ? (
                      <>
                        <Row className="mb-1">
                          <Col md={4} className="fw-semibold text-muted">
                            Medical Aid
                          </Col>
                          <Col md={8}>{patient?.patientMedicalAid || "-"}</Col>
                        </Row>

                        <Row className="mb-1">
                          <Col md={4} className="fw-semibold text-muted">
                            Plan
                          </Col>
                          <Col md={8}>
                            {patient?.patientMedicalAidPlan || "-"}
                            {patient?.patientMedicalAidOption
                              ? ` | ${patient.patientMedicalAidOption}`
                              : ""}
                          </Col>
                        </Row>

                        <Row className="mb-1">
                          <Col md={4} className="fw-semibold text-muted">
                            Number
                          </Col>
                          <Col md={8}>
                            {patient?.patientMedicalAidNumber || "-"}
                          </Col>
                        </Row>

                        <Row className="mb-1">
                          <Col md={4} className="fw-semibold text-muted">
                            Dependant
                          </Col>
                          <Col md={8}>
                            {patient?.patientMedicalAidDependantCode ?? "-"}
                          </Col>
                        </Row>
                      </>
                    ) : (
                      <>
                        <Row className="mb-1">
                          <Col md={4} className="fw-semibold text-muted">
                            IOD Fund
                          </Col>
                          <Col md={8}>{patient?.patientIODFund || "-"}</Col>
                        </Row>

                        <Row className="mb-1">
                          <Col md={4} className="fw-semibold text-muted">
                            Plan
                          </Col>
                          <Col md={8}>
                            {patient?.patientIODPlan || "-"}
                            {patient?.patientIODOption
                              ? ` | ${patient.patientIODOption}`
                              : ""}
                          </Col>
                        </Row>

                        <Row className="mb-1">
                          <Col md={4} className="fw-semibold text-muted">
                            Claim Ref #
                          </Col>
                          <Col md={8}>
                            {patient?.patientIODClaimRefNumber || "-"}
                          </Col>
                        </Row>

                        <Row className="mb-1">
                          <Col md={4} className="fw-semibold text-muted">
                            Employer
                          </Col>
                          <Col md={8}>{patient?.patientIODEmployer || "-"}</Col>
                        </Row>

                        <Row className="mb-1">
                          <Col md={4} className="fw-semibold text-muted">
                            Employer WCA Reg #
                          </Col>
                          <Col md={8}>
                            {patient?.patientIODEmployerWCARegNum || "-"}
                          </Col>
                        </Row>

                        <Row className="mb-1">
                          <Col md={4} className="fw-semibold text-muted">
                            Date of Injury
                          </Col>
                          <Col md={8}>
                            {patient?.patientIODDateOfInjury
                              ? new Date(
                                  patient.patientIODDateOfInjury,
                                ).toLocaleDateString()
                              : "-"}
                          </Col>
                        </Row>
                      </>
                    )}
                  </div>
                );
              })()}

            <hr />
            <Row className="align-items-center mb-3">
              <Col>
                <h5 className="text-primary">Practice(s)</h5>
              </Col>
            </Row>

            {practices && practices.length > 0 && (
              <Row>
                {(() => {
                  const mid = Math.ceil(practices.length / 2);
                  const left = practices.slice(0, mid);
                  const right = practices.slice(mid);

                  return (
                    <>
                      <Col md={6}>
                        {left.map((p) => (
                          <Form.Check
                            key={p.practiceNumber}
                            type="checkbox"
                            id={`practice-${p.practiceNumber}`}
                            label={p.practiceName}
                            checked={selectedPracticeNumbers.includes(
                              p.practiceNumber,
                            )}
                            onChange={() => togglePractice(p.practiceNumber)}
                            className="mb-2"
                          />
                        ))}
                      </Col>
                      <Col md={6}>
                        {right.map((p) => (
                          <Form.Check
                            key={p.practiceNumber}
                            type="checkbox"
                            id={`practice-${p.practiceNumber}`}
                            label={p.practiceName}
                            checked={selectedPracticeNumbers.includes(
                              p.practiceNumber,
                            )}
                            onChange={() => togglePractice(p.practiceNumber)}
                            className="mb-2"
                          />
                        ))}
                      </Col>
                    </>
                  );
                })()}
              </Row>
            )}

            <hr />
            <Row className="align-items-center mb-3">
              <Col>
                <h5 className="text-primary">Patient Information</h5>
              </Col>
              <Col className="text-end">
                <h5
                  className={
                    patient.patientMedicalAidStatus
                      ?.toLowerCase()
                      .includes("active")
                      ? "text-success"
                      : "text-danger"
                  }
                >
                  {patient.patientMedicalAidStatus}
                  {patient.patientMedicalAidStatus &&
                  patient.patientMedicalAidJoinDate
                    ? ` - Joined: ${patient.patientMedicalAidJoinDate}`
                    : ""}
                </h5>
              </Col>
            </Row>
            <Row className="mb-3">
              <Col md={4}>
                <Form.Group as={Col} controlId="formGridPatientnumber">
                  <Form.Label>Patient Number</Form.Label>
                  <Form.Control
                    required
                    placeholder="Custom Patient Number"
                    name="patientNumber"
                    value={patient.patientNumber}
                    onChange={handleChangePatient}
                  />
                </Form.Group>
              </Col>
              <Col md={2}>
                <Form.Group as={Col} controlId="formGridPatientnumber">
                  <Form.Label>Dependant Code:</Form.Label>
                  <Form.Control
                    required
                    name="patientMedicalAidDependantCode"
                    value={patient.patientMedicalAidDependantCode}
                    readOnly={
                      patientMode === "IOD" ||
                      patientMode === "ACCOUNT_HOLDER" ||
                      patientMode === "EXISTING_ACCOUNT"
                    }
                    className={
                      patientMode === "IOD" ||
                      patientMode === "ACCOUNT_HOLDER" ||
                      patientMode === "EXISTING_ACCOUNT"
                        ? "bg-light"
                        : ""
                    }
                    onChange={handleChangePatient}
                  />
                </Form.Group>
              </Col>
            </Row>
            <Row className="mb-3">
              <Col md={2}>
                <Form.Group as={Col} controlId="formGridTitle">
                  <Form.Label>Title</Form.Label>
                  <Form.Select
                    required
                    defaultValue=""
                    name="patientTitle"
                    value={patient.patientTitle}
                    onChange={handleChangePatient}
                  >
                    <option></option>
                    <option>Ms</option>
                    <option>Mr</option>
                    <option>Mrs</option>
                    <option>Dr</option>
                    <option>Prof</option>
                  </Form.Select>
                </Form.Group>
              </Col>
              <Col md={4}>
                <Form.Group as={Col} controlId="formGridFullNames">
                  <Form.Label>Full Name(s)</Form.Label>
                  <Form.Control
                    required
                    name="patientFullNames"
                    value={patient.patientFullNames}
                    onChange={handleChangePatient}
                    readOnly={
                      !!selectedDependant &&
                      !selectedDependant?.errorMessage &&
                      !patientMode === "IOD"
                    }
                    className={
                      selectedDependant &&
                      !selectedDependant?.errorMessage &&
                      !patientMode === "IOD"
                        ? "bg-light"
                        : ""
                    }
                    isInvalid={!!errors.patientFullNames}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.patientFullNames}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
              <Col md={4}>
                <Form.Group as={Col} controlId="formGridLastName">
                  <Form.Label>Last Name</Form.Label>
                  <Form.Control
                    required
                    name="patientLastName"
                    value={patient.patientLastName}
                    onChange={handleChangePatient}
                    readOnly={
                      !!selectedDependant &&
                      !selectedDependant?.errorMessage &&
                      !patientMode === "IOD"
                    }
                    className={
                      selectedDependant &&
                      !selectedDependant?.errorMessage &&
                      !patientMode === "IOD"
                        ? "bg-light"
                        : ""
                    }
                    isInvalid={!!errors.patientLastName}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.patientLastName}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
              <Col md={2}>
                <Form.Group as={Col} controlId="formGridInitials">
                  <Form.Label>Initials</Form.Label>
                  <Form.Control
                    name="patientInitials"
                    value={patient.patientInitials}
                    onChange={handleChangePatient}
                    isInvalid={!!errors.patientInitials}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.patientInitials}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
            </Row>
            <Row className="mb-3">
              <Col md={4}>
                <Form.Group as={Col} controlId="formGridFirstName">
                  <Form.Label>First Name</Form.Label>
                  <Form.Control
                    required
                    value={patient.patientFirstName}
                    name="patientFirstName"
                    onChange={handleChangePatient}
                    readOnly={
                      !!selectedDependant &&
                      !selectedDependant?.errorMessage &&
                      !patientMode === "IOD"
                    }
                    className={
                      selectedDependant &&
                      !selectedDependant?.errorMessage &&
                      !patientMode === "IOD"
                        ? "bg-light"
                        : ""
                    }
                    isInvalid={!!errors.patientFirstName}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.patientFirstName}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>

              <Col md={5}>
                <Form.Group as={Col} controlId="formGridLastName">
                  <Form.Label>ID Number</Form.Label>
                  <Form.Control
                    required
                    value={patient.patientIdNumber}
                    name="patientIdNumber"
                    onChange={handleChangePatient}
                    onBlur={handlePatientIdBlur}
                    readOnly={
                      !!selectedDependant &&
                      !selectedDependant?.errorMessage &&
                      !patientMode === "IOD"
                    }
                    className={
                      selectedDependant &&
                      !selectedDependant?.errorMessage &&
                      !patientMode === "IOD"
                        ? "bg-light"
                        : ""
                    }
                    isInvalid={!!errors.patientIdNumber}
                  />
                  {/*} <Form.Control.Feedback type="invalid">
                    {errors.patientIdNumber}
                  </Form.Control.Feedback> */}
                </Form.Group>
              </Col>
              <Col md={3}>
                <Form.Group as={Col} controlId="formGridDOB">
                  <Form.Label>Date of Birth</Form.Label>
                  <Form.Control
                    required
                    type="date"
                    value={patient.patientDOB}
                    name="patientDOB"
                    onChange={handleChangePatient}
                    readOnly={
                      !!selectedDependant &&
                      !selectedDependant?.errorMessage &&
                      !patientMode === "IOD"
                    }
                    className={
                      selectedDependant &&
                      !selectedDependant?.errorMessage &&
                      !patientMode === "IOD"
                        ? "bg-light"
                        : ""
                    }
                    isInvalid={!!errors.patientDOB}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.patientDOB}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
            </Row>
            <Row className="mb-3">
              <Col md={4}>
                <Form.Group as={Col} controlId="formGridCellPhone">
                  <Form.Label>Mobile Number</Form.Label>
                  <Form.Control
                    required
                    value={patient.patientCellNumber}
                    name="patientCellNumber"
                    onChange={handleChangePatient}
                    isInvalid={!!errors.patientCellNumber}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.patientCellNumber}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
              <Col md={8}>
                <Form.Group as={Col} controlId="formGridEmailAddress">
                  <Form.Label>Email</Form.Label>
                  <Form.Control
                    required
                    value={patient.patientEmail}
                    name="patientEmail"
                    onChange={handleChangePatient}
                    isInvalid={!!errors.patientEmail}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.patientEmail}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
            </Row>
            <Row className="mb-3">
              <Col md={2}>
                <Form.Group as={Col} controlId="formGridTitle">
                  <Form.Label>Gender</Form.Label>
                  <Form.Select
                    required
                    defaultValue=""
                    value={patient.patientGender}
                    name="patientGender"
                    onChange={handleChangePatient}
                    isInvalid={!!errors.patientGender}
                  >
                    <option value=""></option>
                    <option value="2">Female</option>
                    <option value="1">Male</option>
                  </Form.Select>
                  <Form.Control.Feedback type="invalid">
                    {errors.patientGender}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
              <Col md={2}>
                <Form.Group as={Col} controlId="formGridTitle">
                  <Form.Label>Home Language</Form.Label>
                  <Form.Select
                    required
                    defaultValue=""
                    value={patient.patientHomeLanguage}
                    name="patientHomeLanguage"
                    onChange={handleChangePatient}
                  >
                    <option></option>
                    <option>Afrikaans</option>
                    <option>English</option>
                  </Form.Select>
                </Form.Group>
              </Col>
            </Row>
          </Form>
        );
      case 2:
        return (
          <Form>
            <h5 className="text-primary">Account Information</h5>
            <Row className="mb-1">
              {patientMode === "EXISTING_ACCOUNT" && (
                <>
                  <Form.Text className="text-muted mb-1">
                    Please confirm the account details for:
                  </Form.Text>
                  <Row className="mb-1">
                    <Col>
                      <strong>
                        {patientAccount.accountTitle}{" "}
                        {patientAccount.accountInitials}{" "}
                        {patientAccount.accountFirstName}{" "}
                        {patientAccount.accountLastName}
                      </strong>
                    </Col>
                  </Row>
                </>
              )}
            </Row>
            {patientMode !== "EXISTING_ACCOUNT" && (
              <>
                <Form.Text className="text-muted mb-3">
                  Please enter the information for the person responsible for
                  the account.
                </Form.Text>
                {(patientMode === "ACCOUNT_HOLDER" ||
                  patientMode === "IOD") && (
                  <>
                    {/* Row for Title, Initials, First Name, and Last Name */}
                    <Row className="mb-1">
                      <Col>
                        <strong>
                          {patient.patientTitle} {patient.patientInitials}{" "}
                          {patient.patientFirstName} {patient.patientLastName}
                        </strong>
                      </Col>
                    </Row>
                    {/* Row for Phone Number and Medical Aid Information */}
                    <Row className="mb-3">
                      <Col md={6}>
                        <p>
                          <i className="fa-solid fa-id-card text-primary"></i>{" "}
                          {patient.patientIdNumber} <br />
                          <i className="fas fa-phone-alt me-2 text-primary"></i>{" "}
                          {patient.patientCellNumber} <br />
                          <i className="fas fa-envelope me-2 text-primary"></i>{" "}
                          {patient.patientEmail} <br />
                          <i className="fa-regular fa-hashtag me-2 text-primary"></i>{" "}
                          {patientAccount.accountNumber} <br />
                        </p>
                      </Col>
                      {patientMode === "MEDICAL_AID" && (
                        <Col md={6}>
                          <p>
                            <strong>Medical Aid:</strong>{" "}
                            {patient.patientMedicalAid} <br />
                            <strong>Plan:</strong>{" "}
                            {patient.patientMedicalAidOption} |{" "}
                            {patient.patientMedicalAidPlan} <br />
                            <strong>Number:</strong>{" "}
                            {patient.patientMedicalAidNumber}
                          </p>
                        </Col>
                      )}
                      {patientMode === "IOD" && (
                        <Col md={6}>
                          <p>
                            <strong>IOD Fund:</strong> {patient?.patientIODFund}{" "}
                            <br />
                            <strong>Plan:</strong> {patient?.patientIODPlan} |{" "}
                            {patient?.patientIODOption} <br />
                            <strong>Claim Ref Number:</strong>{" "}
                            {patient?.patientIODClaimRefNumber}
                            <br />
                            <strong>Employer:</strong>{" "}
                            {patient?.patientIODEmployer} <br />
                            <strong>Employer WCA Reg #:</strong>{" "}
                            {patient?.patientIODEmployerWCARegNum} <br />
                            <strong>Date of Injury:</strong>{" "}
                            {patient?.patientIODDateOfInjury}
                          </p>
                        </Col>
                      )}
                    </Row>
                  </>
                )}

                {/* Row for Title, Initials, First Name, and Last Name */}
              </>
            )}
            {patientMode !== "ACCOUNT_HOLDER" && patientMode !== "IOD" && (
              <>
                <Row className="mb-3">
                  <Col md={4}>
                    <Form.Group as={Col} controlId="formGridAccountnumber">
                      <Form.Label>Account Number</Form.Label>
                      <Form.Control
                        required
                        placeholder="Custom Account Number"
                        name="accountNumber"
                        value={patientAccount.accountNumber}
                        onChange={handleChangeAccount}
                      />
                    </Form.Group>
                  </Col>
                </Row>
                <Row className="mb-1">
                  <Col md={2}>
                    <Form.Group as={Col} controlId="formGridAccountTitle">
                      <Form.Label>Title</Form.Label>
                      <Form.Select
                        required
                        defaultValue=""
                        name="accountTitle"
                        value={patientAccount.accountTitle}
                        onChange={handleChangeAccount}
                      >
                        <option></option>
                        <option>Ms</option>
                        <option>Mr</option>
                        <option>Mrs</option>
                        <option>Dr</option>
                        <option>Prof</option>
                      </Form.Select>
                    </Form.Group>
                  </Col>
                  <Col md={4}>
                    <Form.Group as={Col} controlId="formGridAccountFullNames">
                      <Form.Label>Full Name(s)</Form.Label>
                      <Form.Control
                        required
                        name="accountFullNames"
                        value={patientAccount.accountFullNames}
                        onChange={handleChangeAccount}
                        readOnly={!!selectedDependant && !selectedDependant?.errorMessage && patientMode !== "IOD"}
                        className={selectedDependant && !selectedDependant?.errorMessage ? "bg-light" : ""}
                        isInvalid={!!errors.accountFullNames}
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.accountFullNames}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                  <Col md={4}>
                    <Form.Group as={Col} controlId="formGridAccountLastName">
                      <Form.Label>Last Name</Form.Label>
                      <Form.Control
                        required
                        name="accountLastName"
                        value={patientAccount.accountLastName}
                        onChange={handleChangeAccount}
                        readOnly={!!selectedDependant && !selectedDependant?.errorMessage && patientMode !== "IOD"}
                        className={selectedDependant && !selectedDependant?.errorMessage ? "bg-light" : ""}
                        isInvalid={!!errors.accountLastName}
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.accountLastName}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                  <Col md={2}>
                    <Form.Group as={Col} controlId="formGridAccountInitials">
                      <Form.Label>Initials</Form.Label>
                      <Form.Control
                        name="accountInitials"
                        value={patientAccount.accountInitials}
                        onChange={handleChangeAccount}
                        readOnly={!!selectedDependant && !selectedDependant?.errorMessage && patientMode !== "IOD"}
                        className={selectedDependant && !selectedDependant?.errorMessage ? "bg-light" : ""}
                        isInvalid={!!errors.accountInitials}
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.accountInitials}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col md={4}>
                    <Form.Group as={Col} controlId="formGridaccountFirstName">
                      <Form.Label>First Name</Form.Label>
                      <Form.Control
                        required
                        value={patientAccount.accountFirstName}
                        name="accountFirstName"
                        onChange={handleChangeAccount}
                        readOnly={!!selectedDependant && !selectedDependant?.errorMessage && patientMode !== "IOD"}
                        className={selectedDependant && !selectedDependant?.errorMessage ? "bg-light" : ""}
                        isInvalid={!!errors.accountFirstName}
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.accountFirstName}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                  <Col md={3}>
                    <Form.Group as={Col} controlId="formGridDOB">
                      <Form.Label>Date of Birth</Form.Label>
                      <Form.Control
                        required
                        type="date"
                        value={patientAccount.accountDOB}
                        name="accountDOB"
                        onChange={handleChangeAccount}
                        readOnly={!!selectedDependant && !selectedDependant?.errorMessage && patientMode !== "IOD"}
                        className={selectedDependant && !selectedDependant?.errorMessage ? "bg-light" : ""}
                        isInvalid={!!errors.accountDOB}
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.accountDOB}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                  <Col md={5}>
                    <Form.Group as={Col} controlId="formGridAccountIdNumber">
                      <Form.Label>ID Number</Form.Label>
                      <Form.Control
                        required
                        value={patientAccount.accountIdNumber}
                        name="accountIdNumber"
                        onChange={handleChangeAccount}
                        onBlur={handleAccountIdBlur}
                        readOnly={!!selectedDependant && !selectedDependant?.errorMessage && patientMode !== "IOD"}
                        className={selectedDependant && !selectedDependant?.errorMessage ? "bg-light" : ""}
                        isInvalid={!!errors.accountIdNumber}
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.accountIdNumber}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col md={4}>
                    <Form.Group controlId="formGridaccountCellPhone">
                      <Form.Label>Mobile Number</Form.Label>
                      <Form.Control
                        required
                        value={patientAccount.accountTelNumberCell}
                        name="accountTelNumberCell"
                        onChange={handleChangeAccount}
                        isInvalid={!!errors.accountTelNumberCell}
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.accountTelNumberCell}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>

                  <Col md={6}>
                    {/* Primary Email */}
                    <Form.Group controlId="formGridAccountEmailAddress">
                      <Form.Label>Email</Form.Label>
                      <InputGroup className="align-items-center">
                        <Form.Control
                          required
                          value={patientAccount.accountEmail}
                          name="accountEmail"
                          onChange={handleChangeAccount}
                          isInvalid={!!errors.accountEmail}
                        />
                        <Button
                          variant="link"
                          className="text-primary d-flex align-items-center"
                          onClick={() => {
                            const nextField = EXTRA_EMAIL_FIELDS.find(
                              (f) => patientAccount[f] === undefined,
                            );
                            if (nextField) {
                              handleChangeAccount({
                                target: { name: nextField, value: "" },
                              });
                            }
                          }}
                          disabled={EXTRA_EMAIL_FIELDS.every(
                            (f) => patientAccount[f] !== undefined,
                          )}
                        >
                          <FaPlus />
                        </Button>
                      </InputGroup>
                      <Form.Control.Feedback type="invalid" className="d-block">
                        {errors.accountEmail}
                      </Form.Control.Feedback>
                    </Form.Group>

                    {/* Additional Emails */}
                    {EXTRA_EMAIL_FIELDS.map((field, idx) => {
                      if (patientAccount[field] === undefined) return null;

                      return (
                        <Form.Group key={field} className="mt-2">
                          <InputGroup className="align-items-center">
                            <Form.Control
                              value={patientAccount[field]}
                              name={field}
                              placeholder={`Additional Email ${idx + 2}`}
                              onChange={handleChangeAccount}
                              isInvalid={!!errors[field]}
                            />
                            <Button
                              variant="link"
                              className="text-danger ms-0 d-flex align-items-center"
                              onClick={() =>
                                handleChangeAccount({
                                  target: { name: field, value: undefined },
                                })
                              }
                            >
                              <FaTrash />
                            </Button>
                            <Form.Control.Feedback type="invalid">
                              {errors[field]}
                            </Form.Control.Feedback>
                          </InputGroup>
                        </Form.Group>
                      );
                    })}
                  </Col>
                </Row>

                <hr />
              </>
            )}
            {/* Row for Home Address Line 1 and Line 2 */}
            <Row className="mb-3">
              {patientMode !== "IOD" && (
                <>
                  <Col md={4}>
                    <Form.Group controlId="formGridEmployer">
                      <Form.Label>Employer</Form.Label>
                      <Form.Control
                        value={patientAccount.accountEmployer}
                        name="accountEmployer"
                        onChange={handleChangeAccount}
                      />
                    </Form.Group>
                  </Col>
                  <Col md={4}>
                    <Form.Group controlId="formGridOccupation">
                      <Form.Label>Occupation</Form.Label>
                      <Form.Control
                        value={patientAccount.accountOccupation}
                        name="accountOccupation"
                        onChange={handleChangeAccount}
                      />
                    </Form.Group>
                  </Col>
                </>
              )}
              <Col md={4}>
                <Form.Group controlId="formGridWorkTelNumber">
                  <Form.Label>Work Phone Number</Form.Label>
                  <Form.Control
                    value={patientAccount.accountTelNumberWork}
                    name="accountTelNumberWork"
                    onChange={handleChangeAccount}
                  />
                </Form.Group>
              </Col>
            </Row>
            {/* Horizontal Line */}
            <hr />
            {/* Row for Home Address Line 1 and Line 2 */}
            <Row className="mb-3">
              <Col md={4}>
                <Form.Group controlId="formGridWorkTelNumber">
                  <Form.Label>Home Phone Number</Form.Label>
                  <Form.Control
                    value={patientAccount.accountTelNumberHome}
                    name="accountTelNumberHome"
                    onChange={handleChangeAccount}
                  />
                </Form.Group>
              </Col>
            </Row>
            <Row className="mb-3">
              <Col md={6}>
                <Form.Group controlId="formGridHomeAddress">
                  <Form.Label>Home Address 1</Form.Label>
                  <Form.Control
                    required
                    value={patientAccount.accountHomeAddress1}
                    name="accountHomeAddress1"
                    onChange={handleChangeAccount}
                  />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group controlId="formGridHomeAddress2">
                  <Form.Label>Home Address 2</Form.Label>
                  <Form.Control
                    required
                    value={patientAccount.accountHomeAddress2}
                    name="accountHomeAddress2"
                    onChange={handleChangeAccount}
                  />
                </Form.Group>
              </Col>
            </Row>

            {/* Row for City and Province */}
            <Row className="mb-3">
              <Col md={4}>
                <Form.Group controlId="formGridHomeAddressCity">
                  <Form.Label>City</Form.Label>
                  <Form.Control
                    required
                    value={patientAccount.accountHomeAddressCity}
                    name="accountHomeAddressCity"
                    onChange={handleChangeAccount}
                  />
                </Form.Group>
              </Col>
              <Col md={4}>
                <Form.Group
                  as={Col}
                  controlId="formGridaccountHomeAddressProvince"
                >
                  <Form.Label>Province</Form.Label>
                  <Form.Select
                    defaultValue="Choose..."
                    value={patientAccount.accountHomeAddressProvince}
                    name="accountHomeAddressProvince"
                    onChange={handleChangeAccount}
                  >
                    <option>Choose...</option>
                    <option>Eastern Cape</option>
                    <option>Free State</option>
                    <option>Gauteng</option>
                    <option>KwaZulu-Natal</option>
                    <option>Limpopo</option>
                    <option>Mpumalanga</option>
                    <option>North West</option>
                    <option>Northern Cape</option>
                    <option>Western Cape</option>
                  </Form.Select>
                </Form.Group>
              </Col>
              <Col md={4}>
                <Form.Group controlId="formGridaccountHomeAddress">
                  <Form.Label>Postal Code</Form.Label>
                  <Form.Control
                    required
                    value={patientAccount.accountHomeAddressPostalCode}
                    name="accountHomeAddressPostalCode"
                    onChange={handleChangeAccount}
                  />
                </Form.Group>
              </Col>
            </Row>
            <Row className="mb-1 mt-3">
              <Form.Group as={Col} controlId="checkboxGroup">
                <Form.Check
                  type="switch"
                  label="The postal address is different from the home address"
                  name="accountPostal"
                  value="false"
                  onChange={handleChangeAccount}
                />
              </Form.Group>
            </Row>
            {postalAddress && (
              <>
                <Row>
                  <Col md={6}>
                    <Form.Group controlId="formGridPostalAddress1">
                      <Form.Label>Postal Address 1</Form.Label>
                      <Form.Control
                        required
                        value={patientAccount.accountPostalAddress1}
                        name="accountPostalAddress1"
                        onChange={handleChangeAccount}
                      />
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <Form.Group controlId="formGridPostAddress2">
                      <Form.Label>Home Address 2</Form.Label>
                      <Form.Control
                        required
                        value={patientAccount.accountPostalAddress2}
                        name="accountPostalAddress2"
                        onChange={handleChangeAccount}
                      />
                    </Form.Group>
                  </Col>
                </Row>

                {/* Row for City and Province */}
                <Row className="mb-3">
                  <Col md={4}>
                    <Form.Group controlId="formGridPostAddressCity">
                      <Form.Label>City</Form.Label>
                      <Form.Control
                        required
                        value={patientAccount.accountPostalAddressCity}
                        name="accountPostalAddressCity"
                        onChange={handleChangeAccount}
                      />
                    </Form.Group>
                  </Col>
                  <Col md={4}>
                    <Form.Group as={Col} controlId="formPostState">
                      <Form.Label>Province</Form.Label>
                      <Form.Select
                        defaultValue="Choose..."
                        value={patientAccount.accountPostalAddressProvince}
                        name="accountPostalAddressProvince"
                        onChange={handleChangeAccount}
                      >
                        <option>Choose...</option>
                        <option>Eastern Cape</option>
                        <option>Free State</option>
                        <option>Gauteng</option>
                        <option>KwaZulu-Natal</option>
                        <option>Limpopo</option>
                        <option>Mpumalanga</option>
                        <option>North West</option>
                        <option>Northern Cape</option>
                        <option>Western Cape</option>
                      </Form.Select>
                    </Form.Group>
                  </Col>
                  <Col md={4}>
                    <Form.Group controlId="formGridPostAddressPostal">
                      <Form.Label>Postal Code</Form.Label>
                      <Form.Control
                        required
                        value={patientAccount.accountPostalAddressPostalCode}
                        name="accountPostalAddressPostalCode"
                        onChange={handleChangeAccount}
                      />
                    </Form.Group>
                  </Col>
                </Row>
              </>
            )}
          </Form>
        );
      case 3:
        return (
          <Form>
            <h5 className="text-primary">Referral</h5>
            <Row className="mt-1">
              <Form.Text>
                Referral information is only required if the patient was
                referred by another practitioner. It's not required to save the
                patient.
              </Form.Text>
              <Form.Text></Form.Text>
            </Row>
            <Row className="mb-3">
              <Col md={8}>
                <Form.Group as={Col} controlId="formGridAccountFullNames">
                  <Form.Label>Referred By</Form.Label>
                  <Form.Control
                    required
                    name="patientReferredBy"
                    value={patient.patientReferredBy}
                    onChange={handleChangeReferral}
                  />
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col md={12}>
                <Form.Group as={Col} controlId="formGridAccountLastName">
                  <Form.Label>Referall Notes</Form.Label>
                  <Form.Control
                    className="w-100"
                    as="textarea"
                    rows={3}
                    required
                    name="patientReferredNotes"
                    value={patient.patientReferredNotes}
                    onChange={handleChangeReferral}
                  />
                </Form.Group>
              </Col>
            </Row>
            <hr />
            {alerts && (
              <Alert
                variant="success"
                onClose={() => setAlerts(false)}
                dismissible
              >
                The patient was successfully added!
              </Alert>
            )}
          </Form>
        );
      default:
        return null;
    }
  };

  return (
    <>
      <Modal
        {...props}
        backdrop="static"
        size="lg"
        dialogClassName="modal-80w"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        onHide={handleClose}
      >
        <Modal.Header
          closeButton={!(closeAlert || multipleAccountsError || notFoundAlert)}
          className="border-secondary"
        >
          <div className="w-100">
            <Modal.Title
              id="contained-modal-title-vcenter"
              className="text-primary fs-6"
            >
              <Nav
                className="justify-content-center align-items-center step-nav"
                activeKey={currentStep}
              >
                <Nav.Item className="position-relative">
                  <Nav.Link
                    className={`${
                      currentStep === 1
                        ? "active fw-bold"
                        : "disabled text-muted"
                    }`}
                  >
                    1. Patient Information
                  </Nav.Link>
                </Nav.Item>
                <div className={cssc.stepline}></div>
                <Nav.Item className="position-relative">
                  <Nav.Link
                    className={`${
                      currentStep === 2
                        ? "active fw-bold"
                        : "disabled text-muted"
                    }`}
                  >
                    2. Account Information
                  </Nav.Link>
                </Nav.Item>
                <div className={cssc.stepline}></div>
                <Nav.Item className="position-relative">
                  <Nav.Link
                    className={`${
                      currentStep === 3
                        ? "active fw-bold"
                        : "disabled text-muted"
                    }`}
                  >
                    3. Referral Information
                  </Nav.Link>
                </Nav.Item>
              </Nav>
            </Modal.Title>
          </div>
        </Modal.Header>

        {closeAlert && (
          <Alert
            variant="info"
            className="w-100 d-flex align-items-center justify-content-between mx-0 mb-0 fs-6 fw-normal border-0 rounded-0"
            onClose={() => setCloseAlert(false)}
          >
            <span>
              Are you sure you want to close? The entered data will be removed.
            </span>
            <div className="ms-auto d-flex">
              <Button
                variant="outline-primary"
                className="btn btn-outline-primary me-1"
                onClick={handleCancelYes}
              >
                <FaCheck />
              </Button>
              <Button
                variant="outline-secondary"
                className="btn btn-outline-secondary me-1"
                onClick={handleCancelNo}
              >
                <FaTimes />
              </Button>
            </div>
          </Alert>
        )}

        {multipleAccountsError && (
          <Alert
            variant="danger"
            className="w-100 d-flex align-items-center justify-content-between mx-0 mb-0 fs-6 fw-normal border-0 rounded-0"
            onClose={() => setMultipleAccountsError(false)}
          >
            <span>{multipleAccountsErrorMessage}</span>
            <Button
              variant="outline-primary"
              className="btn btn-outline-primary me-1"
              onClick={() => setMultipleAccountsError(false)}
            >
              <FaTimes />
            </Button>
          </Alert>
        )}

        {notFoundAlert && (
          <Alert
            variant="warning"
            className="w-100 d-flex align-items-center justify-content-between mx-0 mb-0 fs-6 fw-normal border-0 rounded-0"
            onClose={() => setNotFoundAlert(false)}
          >
            <span>
              The main member's online medical aid record couldn't be retrieved,
              this could be due to it either not being available from the fund
              or a connection issue. Please ensure to enter the the patient's{" "}
              <strong>dependant code</strong>. The Medical Aid information
              searched on will be saved against the patient record.
            </span>
            <Button
              variant="outline-primary"
              className="btn btn-outline-primary me-1"
              onClick={() => setNotFoundAlert(false)}
            >
              <FaTimes />
            </Button>
          </Alert>
        )}

        <Modal.Body>
          <div className="step-content">{renderContent(currentStep)}</div>
        </Modal.Body>
        <Modal.Footer>
          {currentStep !== 1 && (
            <Button variant="secondary w-25" onClick={handlePrevious}>
              Previous
            </Button>
          )}

          {currentStep !== 3 && (
            <Button variant="primary w-25" onClick={handleNext}>
              Next
            </Button>
          )}
          {currentStep === 3 && (
            <Button variant="primary w-25" onClick={handleSave}>
              Submit
            </Button>
          )}
        </Modal.Footer>
      </Modal>
    </>
  );
}

export function AddPatientSteps({
  show,
  onHide,
  appointmentId,
  patientFirstName,
  patientLastName,
  patientEmail,
  patientCellNumber,
  onSaved,
}) {
  return (
    <>
      <PatientInformationModal
        show={show}
        onHide={onHide}
        patientFirstName={patientFirstName}
        patientLastName={patientLastName}
        patientEmail={patientEmail}
        patientCellNumber={patientCellNumber}
        appointmentId={appointmentId}
        onSaved={onSaved}
      />
    </>
  );
}
